import { LocalStorageService } from './local-storage/local-storage.service';
import { TokenSessionService } from './session';
import { WindowWrapperService } from './window-wrapper';
import { PostMessageService } from './post-message';
import { SubscriptionCheckService } from './subscription-check/subscription-check.service';
import { PermissionService } from './permission/permission.service';
import { NavigateService } from './navigate/navigate.service';
import { ModalNotificationService } from './modal-notification';
import { NumberFormatService } from './number-format/number-format.service';
import { CountryFormatService } from './country-format/country-format.service';
import { ThemeService } from './theme';

export const UTILITY_SERVICES: any[] = [
  WindowWrapperService,
  LocalStorageService,
  TokenSessionService,
  PostMessageService,
  SubscriptionCheckService,
  PermissionService,
  NavigateService,
  ModalNotificationService,
  NumberFormatService,
  CountryFormatService,
  ThemeService,
];
